import React, {Component} from 'react';
import {close_popup} from "../functions";
import RedirectOnlyHome from "../common/RedirectOnlyHome";
import SignatureComponent from "./Signature";

class TermsConditionsPopup extends Component {
	constructor(props) {
		super(props);
		this.goNext = this.goNext.bind(this);
		this.proceed = this.proceed.bind(this);
		this.goBack = this.goBack.bind(this);

		this.state = {
			signature_json: "{\"lines\":[]}",
			signature_png: "",
			terms_1: "0",
			terms_2: "0",
			terms_3: "0",
			terms_4: "0",
			terms_5: "0",
//			terms_6: "0",
			current_term: 1,
			status: "confirmed",
			signatureError: 'This field is required',
			signatureDirty: false
		};

		if (
			(this.props.booking_form_data.booking.alternative_location === undefined || this.props.booking_form_data.booking.alternative_location === "") &&
			(this.props.booking_form_data.booking.alternative_pickupdate === undefined || this.props.booking_form_data.booking.alternative_pickupdate === "")
		)
			this.state.current_term = 2;
	}

	goNext() {
		this.setState((prevState, prevProps) => {
			let term = 'terms_'+prevState.current_term;
			let inc = 1;
			if (prevState.current_term === 2 && parseInt(this.props.booking_form_data.booking.additional_drivers) === 0)
				inc = 2;
			if (prevState.current_term === 6)
				inc = 0;

			return {current_term: prevState.current_term + inc, [term]: "1"};
		});

		if (this.state.current_term > 5){
			this.proceed();
		}
	}
	//Set callback to obtain signature JSON and PNG from SignatureComponent
	setSignatureCallback = (callback) => {this.signatureCallback = callback;}

	proceed() {
		let {signature_json, signature_png} = this.signatureCallback();
		let signature = this.state.signature_json;
		let validate = false;

		if (signature_json)
			signature = JSON.parse(signature_json);

		if (!signature || !signature.lines || !signature.lines.length) {
			this.setState({signatureDirty: true});
			validate = false;
		}
		else {
			let count = 0;
			for (let i=0; i<signature.lines.length; i++ ) {
				count += signature.lines[i].length;
			}

			if (count < 7) {
				this.setState({signatureDirty: true, signatureError: 'Your signature is very simple'});
				validate = false
			}
			else {
				this.setState({signatureDirty: false, signatureError: ''});
				validate = true;
			}
		}

		if (validate) {
			this.setState({signature_json: signature_json, signature_png: signature_png, signatureDirty: false});

			this.props.handleTermsConditionsPopup(signature_json, signature_png, this.state.terms_1, this.state.terms_2, this.state.terms_3, this.state.terms_4, this.state.terms_5/*, this.state.terms_6*/, this.state.status);
			close_popup();
			this.props.goNext();

			this.props.handleSetSomeBlock('scroll_to_element', 'id_drivers_div');
		}
	}

	goBack() {
		close_popup();
	}

	render() {
		return (<>
			<RedirectOnlyHome />

			<div id={'agreements'}>
				<div style={{padding:"30px"}}>
					{
						this.state.current_term === 1 &&
						<div className="row terms terms_1">
							<div className="col">
								<div className="form-check-label">
									<img src="../../wp-content/plugins/booking-form/images/thumb-up-gecko.png"
										 alt="gecko"
										 style={{float: "left", margin: "0 20px 0 0"}}/>
									<h4 style={{
										background: "#d63545",
										marginLeft: "70px",
										padding: "5px 0 5px 10px",
										color: "white"
									}}> JUST CONFIRMING?...</h4>
									<div className="terms-text_2">
										<p>You're booking a vehicle that doesn't match your original search criteria, but
											rather
											one of our helpful alternate options.</p>
										<div className="row text-center">
											<p className="available_variant_vehicle_p">
												<i className="icon-location available_variant_vehicle_i"></i><span
												id="bf_selected_location">{this.props.to_show.selected_location}</span>
											</p>
										</div>
										<div className="row text-center" style={{marginBottom: "20px"}}>
											<div className="col-md-5 truck-picture"
												 style={this.props.to_show.truck_picture}>
											</div>
											<div className="col-md-7 available_variant_vehicle_text">
												<h3 className="available_variant_vehicle_title">
													<i className="icon3-sports-car available_variant_vehicle_i"></i>
													<span id="bf_selected_car">{this.props.to_show.selected_car}</span>
												</h3>
												<div><i className="icon-clock2 available_variant_begin_i"></i> Pickup Date : <span
													id="bf_selected_pickup">{this.props.to_show.selected_pickup}</span>
												</div>
												<div>
													<i className="icon-clock2 available_variant_end_i"></i> Dropoff Date : <span
														id="bf_selected_dropoff">{this.props.to_show.selected_dropoff}</span>
												</div>
											</div>
										</div>
										<p className="text-center"><b>IS THIS ACCURATE?</b></p>
									</div>
								</div>
							</div>
						</div>
					}
					{
						this.state.current_term === 2 &&
						<div className="row terms terms_2">
							<div className="col">
								<div className="form-check-label">
									<h4>Rental Agreement and Terms &amp; Conditions</h4>
									<div className="terms-text" dangerouslySetInnerHTML={{__html: window.terms_conditions}}>
									</div>
									<p><b>You understand &amp; accept all Hire Terms and conditions shown above?</b></p>
								</div>
							</div>
						</div>
					}
					{
						this.state.current_term === 3 &&
						<div className="row terms terms_3">
							<div className="col">
								<div className="form-check-label">
									<h4>Use of additional drivers</h4>
									<p>You acknowledge your additional Driver is aged between 23 – 75 and their
										adherence to all
										Terms and Conditions?</p>
								</div>
							</div>
						</div>
					}
					{
						this.state.current_term === 4 &&
						<div className="row terms terms_4">
							<div className="col">
								<div className="form-check-label">
									<h4>Use of tolls roads and toll charges</h4>
									<div className="terms-text_2">
										<p>I understand Toll charges are NOT included for this hire. I am responsible for
											and must
											pay ALL Road Tolls incurred during my hire period as outlined in Section 9 of
											the Rental
											Agreement.</p>
										<p>In the event, I use a Toll road(s) and Go with the Gecko, are charged for my use
											of the
											Toll Road(s) by the Toll Authority (Linkt), I authorise, Go With The Gecko to
											charge the
											cost of these Toll Charges, plus an administration fee of $6 per Toll to my
											Hire
											Account, and charge the credit card held on my hire account for these charges or
											to
											deduct these charges from my security deposit, prior to its return.</p>
									</div>
								</div>
							</div>
						</div>
					}
					{
						this.state.current_term === 5 &&
						<div className="row terms terms_5">
							<div className="col">
								<div className="form-check-label">
									<h4>Photo verification</h4>
									<div className="terms-text_2">
										<p>I agree to submit the nominated Vehicle condition and Hirer Identification Photos
											as
											outlined in section 4.14 of my Hire Agreement via the nominated Book N Go App
											(or via
											the web link provided) before the Hire commences and again when returning the
											Vehicle.</p>
										<p>I understand and accept that failure to submit these photos through our Book N Go
											App (or
											via the web link provided) within a 24hr period from the pickup or return of the
											vehicle, may result in fees being applied to my account and may affect my
											ability to
											dispute any Damage detected at the end of the Rental Period is my
											responsibility.</p>
									</div>
								</div>
							</div>
						</div>
					}
					{/*
						this.state.current_term === 6 &&
						<div className="row terms terms_6">
							<div className="col">
								<div className="form-check-label">
									<h4>COVID-19</h4>
									<p>I AGREE to follow all state legislation in relation to the use of this Hire
										Vehicle
										during the COVID-19 pandemic, including but not limited to the use of face-masks
										whilst
										driving the vehicle, travel permits, and sanitising the Vehicle prior to
										returning.</p>
									<h4>Cancellation due to COVID-19</h4>
									<p>I understand that should my booking be affected or canceled due to COVID-19
										restrictions
										for any reason whatsoever, I am entitled to a CREDIT NOTE for the full value of
										the hire
										or pro-rata value only. This credit note is valid for 12 months from the date of
										cancellation.</p>
								</div>
							</div>
						</div>
					*/}
					{
						this.state.current_term === 6 &&
						<div className="row terms signature" style={{display: "block"}}>
							<h4>Signature</h4>
							<div className={'form-group col-md-12 '+((this.state.signatureDirty && this.state.signatureError) && 'has-danger')}>
								{/*<div id="id_signature" className="signature kbw-signature">
								<canvas width="721" height="250">Your browser doesn't support signing</canvas>
							</div>
							<h3 className="label_signature">Add Your Signature <span className="star">*</span></h3>
							<span className="clear_signature">Clear</span>*/}
								<SignatureComponent signatureCallback={this.setSignatureCallback}/>
								{
									(this.state.signatureDirty && this.state.signatureError) &&
										<small className="form-control-feedback d-block">{this.state.signatureError}</small>
								}
							</div>
						</div>
					}
					<div className="radio agreements_toggle btn-group">
						<label htmlFor="terms_2_0" className="btn btn-success">
							<input type="radio" name="booking[terms_2]"
								 id="terms_2_0" value="0" readOnly={this}
								 data-name="terms_2" checked="checked" onClick={this.goBack}/>No
						</label>
						<label htmlFor="terms_2_1" className="btn btn-outline-success">
							<input type="radio" name="booking[terms_2]"
								 id="terms_2_1" value="1" readOnly={this}
								 data-name="terms_2" checked="checked" onClick={this.goNext}/>Yes
						</label>
					</div>
				</div>
			</div>
		</>);
	}
}

export default TermsConditionsPopup;